module.exports = __webpack_public_path__ + "static/media/mode-66.91d477ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-66.svg
// module id = 1037
// module chunks = 2